import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog"; // Message Box

interface Props {
  Menuprops: menuInfo;
}

const SN_MAS_BAS_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const { userInfo } = global();
  const [gridFocus, setGridFocus] = useState(false);

  // 특정 셀 색상 변경할 때
  document.documentElement.style.setProperty("--custom_bg", "#e8f5e9");
  document.documentElement.style.setProperty("--custom_text", "#1b5e20");
  document.documentElement.style.setProperty("--custom_header_bg", "#e8f5e9");
  document.documentElement.style.setProperty("--custom_header_text", "#1b5e20");

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        const styledColumns = rtn.grid.grid1.map((col: any) => {
          if (col.cd_column === "total_ct") {
            return {
              ...col,
              // GridV2 는 cellClass/headerClass 를 받지 않아 cellStyle 로 대체 (헤더 색상은 미적용)
              cellStyle: { backgroundColor: "#e8f5e9", color: "#1b5e20" },
            };
          }
          return col;
        });
        setColums({ grid1: styledColumns });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    getGridCurrent("grid1").selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_mas_bas_rep_001_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({ grid1: data[0] });

      setGridFocus(true);
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onPrint,
  }));

  const onPrint = async () => {
    getGridCurrent("grid1").stopEditing();
    let isPrintable = true; // 인쇄 가능 여부 플래그
    const nmArray: string[] = [];
    const itemArray: string[] = [];
    const qtArray: string[] = [];
    const checkedRows = getGridCurrent("grid1").getCheckedRows();
    for (const object of checkedRows) {
      if (object.total_ct === null || object.total_ct === 0) {
        isPrintable = false; // 포장 합계가 없거나 0이므로 인쇄 불가능 표시
        break; // 하나라도 인쇄 불가능하면 바로 중단
      } else if (object.qt_ct === null || object.qt_ct === 0) {
        nmArray.push(object.nm_item);
        itemArray.push(object.cd_item);
        qtArray.push(object.total_ct);
        continue;
      }

      let flagDiv = object.total_ct;

      while (flagDiv - object.qt_ct >= 0) {
        flagDiv -= object.qt_ct;
        nmArray.push(object.nm_item);
        itemArray.push(object.cd_item);
        qtArray.push(object.qt_ct.toString());
      }
      if (flagDiv != 0 && flagDiv - object.qt_ct < 0) {
        nmArray.push(object.nm_item);
        itemArray.push(object.cd_item);
        qtArray.push(flagDiv.toString());
      }
    }

    if (!isPrintable) {
      await showDialog("alert", "포장합계가 없습니다.");
      return false; // 인쇄 중단
    }

    const nm = nmArray.join(",");
    const item = itemArray.join(",");
    const qt = qtArray.join(",");
    getGridCurrent("grid1").resetUpdate();
    // 결과 객체 반환
    return {
      nm_item: nm,
      cd_item: item,
      qt_ct: qt,
    };
  };

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            title: "품목정보",
            isEditable: true,
            ischeckboxSelection: true,
          }}
        />
      </div>
    </div>
  );
});

export default SN_MAS_BAS_REP_001;
